import { Injectable } from '@angular/core';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { SLLayer } from '../model/sl-layer';
import { SlWapiService } from '../model/api-services/sl-wapi.service';

@Injectable({
	providedIn: 'root'
})
export class ShpExportService {

	constructor(private wapi: SlWapiService) {
	}
	ExportSHP(messager: ModalMessagerService,
		fileName: string,
		layer: SLLayer,
		cols: Array<string>, data: Array<any>, rawMode: boolean = false, projectionParams?: any) {
		const fields = [];
		const nonCols = ['_checkbox_selector', '_sl_actions']
		for (const col of cols) {
			if (nonCols.indexOf(col) > -1) {
				continue;
			}
			fields.push(col);
		}
		const gids: string = SLLayer.GetGids(data, true) as string;
		const params: any = {
			gids: (gids),
			fields: (fields)
		}
		if (layer.isPLayer === true) {
			params.plid = layer.plid;
		} else {
			params.lid = layer.id;
		}
		if (!projectionParams) {
			params.srs = 'layer';
		} else {
			for (const prjParam in projectionParams) {
				if (projectionParams.hasOwnProperty(prjParam)) {
					params[prjParam] = projectionParams[prjParam];
				}
			}
		}

		messager.RequestDownload(
			{
				extension: 'zip',
				mimeType: 'application/zip',
				defaultFileName: 'ResultsFrom_' + layer.name.replace(/ /g, '_')
			},
			'layers/download/shp',
			params,
			'Export results to ESRI Shape File '
		);
		// this.wapi.DownloadFile('layers/download/kml/', params, 'application/vnd', fileName);
	}
}
